<div class="login-container">
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <a routerlink="/" href="/" data-testid="login-logo-link"
      ><img class="login-logo" src="../../assets/img/logo.png" alt="logo"
    /></a>
    <div class="form-control">
      <input
        id="email"
        type="email"
        class="input"
        formControlName="email"
        placeholder="Email"
        maxlength="50"
        required
        (keydown)="clearValidations()"
        autocomplete="disabled"
        data-testid="login-email"
      />
      <div
        *ngIf="
          loginForm.controls['email']?.invalid &&
          (loginForm.controls['email'].dirty ||
            loginForm.controls['email'].touched)
        "
      >
        <div
          class="error-message"
          *ngIf="loginForm.controls['email'].errors?.['required']"
        >
          Email is required.
        </div>
      </div>
    </div>
    <div class="form-control">
      <input
        id="password"
        [type]="showPassword ? 'text' : 'password'"
        class="input"
        formControlName="password"
        placeholder="Password"
        maxlength="100"
        (keydown)="clearValidations()"
        (blur)="trimPassword()"
        data-testid="login-password"
      />
      <div class="show-password"
        (click)="togglePasswordVisibility()"
        data-testid="login-password-toggle">
        <span class="material-icons">{{!showPassword ? 'visibility' : 'visibility_off'}}</span>
      </div>
      <div
        *ngIf="
          loginForm.controls['password']?.invalid &&
          (loginForm.controls['password'].dirty ||
            loginForm.controls['password'].touched)
        "
      >
        <div
          *ngIf="loginForm.controls['password'].errors?.['required']"
          class="error-message"
        >
          Password is required.
        </div>
      </div>
      <div class="error-message" *ngIf="!isValid">
        Email or password is incorrect.
      </div>
    </div>
    <div class="kmsi-field">
      <label class="kmsi-label" for="keepMeSignedIn">
        <input
          id="keepMeSignedIn"
          type="checkbox"
          formControlName="keepMeSignedIn"
          aria-describedby="kmsi-help kmsi-warn"
          data-testid="login-keep-signed-in"
        />
        <span>Keep me signed in on this device</span>
      </label>
      <span class="kmsi-help" id="kmsi-help">
        Skip logging in for up to 90 days — only on a device that's yours.
        <span class="kmsi-warn" id="kmsi-warn">Don't use this on a shared or public computer.</span>
      </span>
    </div>
    <div class="panel-fields">
      <div>
        <a routerLink="/forgotpassword" class="login-links" data-testid="login-forgot-link">
          Forgot Password?</a
        >
      </div>
    </div>
    <button type="submit" class="btn btn-primary" [disabled]="isSubmitting" data-testid="login-submit">Login</button>
    <hr />
    <div class="new-account">
      <a routerLink="/createaccount" class="new-account" data-testid="login-create-account-link">
        Don’t have an account?
      </a>
    </div>
    <button type="button" class="btn btn-default" (click)="navigateRegister()" data-testid="login-register">
      Register
    </button>
  </form>
</div>
